/* eslint-disable @typescript-eslint/no-misused-promises */
import React from 'react'
import _ from 'lodash'
// import MCIcon from 'react-native-vector-icons/MaterialCommunityIcons'
import XContainer from 'xui/components/XContainer'
import XContent from 'xui/components/XContent'
import BaseSelectedSubscriptionPackageView from 'x/modules/subscription/BaseSelectedSubscriptionPackageView'
import { COLORS, STYLES } from 'x/config/styles'
import * as xFmt from 'x/utils/formatter'
import p from 'x/config/platform-specific'
import XCustomHeader from 'xui/components/XCustomHeader'
import ProfilePackage from 'xui/components/ProfilePackage'
import HStack from 'xui/components/HStack'
import XText from 'xui/components/XText'
import XCapsuleSegment, { IOptionsCapsuleSegment } from 'xui/components/XCapsuleSegment'
import VStack from 'xui/components/VStack'
import XCard from 'xui/components/XCard'
import { TouchableOpacity, Clipboard, Linking } from 'react-native'
import * as util from 'x/utils/util'
import * as subscriptionUtil from 'x/utils/subscriptionUtil'
import * as addressUtil from 'x/utils/addressutil'
import XIcon from 'xui/components/XIcon'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XButton from 'xui/components/XButton'
import XDocumentDropzone from 'xui/components/XDocumentDropzone'
import XDateTimeSinglePicker from 'xui/components/XDateTimeSinglePicker'
import XSpinner from 'xui/components/XSpinner'
import dayjs from 'dayjs'
import XOverlay from 'xui/components/XOverlay'
import ChangeBillingCycle from './ChangeBillingCycle'
import XPendingSubcriptionPayment from './XPendingSubcriptionPayment'
import XOrderCountHistory from './XOrderCountHistory'

// import { withIAPContext } from 'react-native-iap'
// import { createStackNavigator } from '@react-navigation/stack'
const IMG_DISCOUNT = require('../../img/discount/discount_red.png')

const BRONZ_BG = require('../../img/packge_bg/bronz.png')
const SILVER_BG = require('../../img/packge_bg/silver.png')
const GOLD_BG = require('../../img/packge_bg/gold.png')
const PLATINUM_BG = require('../../img/packge_bg/platinum.png')

const IMG_SCB = require('../../img/banks/scb.png')

const OPTIONS_NEW_SEGMENT: IOptionsCapsuleSegment[] = [
  {
    text: '1 เดือน',
  },
  {
    text: '3 เดือน',
    // labelView: <XImage source={IMG_DISCOUNT} w={50} h={50} />,
  },
  {
    text: '6 เดือน',
    // labelView: <XImage source={SILVER_BG} w={20} h={30} mt='2' />,
  },
  {
    text: '12 เดือน',
    // labelView: <XImage source={PLATINUM_BG} w={20} h={30} />,
  },
]

export default abstract class BaseUISelectedSubscriptionPackageView extends BaseSelectedSubscriptionPackageView {
  _renderHeader = () => {
    const { mode } = this.state
    let title = 'ซื้อแพ็กเกจ'
    if (mode === 'add_on') {
      title = 'ซื้อแพ็กเกจเสริม'
    }
    if (mode === 'upgrade') {
      title = 'อัปเกรดแพ็กเกจ'
    }
    return (
      <XCustomHeader
        title={title}
        headerLeftProps={{
          backIcon: true,
          onPressItem: () => {
            // const params = this._getParams()
            // const { succeedPaymentCallBack } = params
            // if (_.isFunction(succeedPaymentCallBack)) {
            //   succeedPaymentCallBack()succeedPaymentCallBack
            // }
            this.goBack()
          },
        }}
        // renderHeaderRight={this._renderHeaderRight}
      />
    )
  }

  _renderProfile = () => {
    const { subscription } = this.props
    const { profile } = this.state
    // console.log('profile // => ', profile)
    if (_.isNil(profile) || _.isNil(subscription)) {
      return null
    }
    const typeId: number = subscription.has('type') ? subscription.get('type') : 0
    // console.log('profile => ', profile)
    return <ProfilePackage profile={profile} typeId={typeId} />
  }

  _renderTitleDescription = () => {
    const { pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return null
    }
    return (
      <HStack w='full' alignItems='center' justifyContent='center' mt='2' h='16'>
        <XText fontSize='lg' textAlign='center'>
          {'เลือกซื้อแพ็กเกจได้อย่างอิสระ\nในทุกแบบที่คุณต้องการ'}
        </XText>
      </HStack>
    )
  }

  _renderSelectedMonthPackage = () => {
    const { selectedOptionRangePackageIndex } = this.state
    return (
      <HStack px='2' mt='2'>
        <XCapsuleSegment
          options={OPTIONS_NEW_SEGMENT}
          onSegmentChange={(newIndex: number) => this.setState({ selectedOptionRangePackageIndex: newIndex })}
          sectedIndex={selectedOptionRangePackageIndex}
        />
      </HStack>
    )
  }

  _renderMySelectedPackage = () => {
    const { selectedMainPackage, pendingOrderData, mode, subscriptionPackageList } = this.state
    // console.log('_renderMySelectedPackage selectedMainPackage => ', selectedMainPackage)
    if (_.isNil(selectedMainPackage) || mode === 'add_on') {
      return null
    }
    let packageName = `แพ็กเกจ ${util.getSubscriptionTypeFullNameBySubType(selectedMainPackage.item_subtype)}`
    const priceWithVat = selectedMainPackage.price_with_vat
    // const billingCycleDateTime = this._getStartAndEndBillingCycle(selectedMainPackage.billing_cycle)
    const pendingModeCheck = subscriptionUtil.pendingModeCheck(selectedMainPackage, mode)
    const billingCycleDateTime = util.getStartAndEndBillingCycle(
      subscriptionPackageList,
      selectedMainPackage.billing_cycle,
      pendingModeCheck
    )
    // console.log('mode => ', mode)
    if (mode === 'upgrade' || mode === 'pending') {
      packageName = selectedMainPackage.name
    }
    // if (mode === 'pending') {
    //   priceWithVat *= selectedMainPackage.billing_cycle
    // }
    return (
      <XCard mx='2' mt='2'>
        <VStack w='full'>
          <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10'>
            <XText textAlign='center' bold fontSize='lg'>
              แพ็กเกจที่เลือก
            </XText>
          </HStack>

          <VStack p='2'>
            <HStack w='full'>
              <HStack flex={3}>
                <XText bold variant='active'>{`${packageName}`}</XText>
                {_.isNil(pendingOrderData) && mode !== 'upgrade' ? (
                  <TouchableOpacity
                    style={{ marginLeft: 4, paddingBottom: 4, width: 40 }}
                    onPress={() => this._onClickChangeContinuePackage()}>
                    <XText variant='inactive' textDecorationLine='underline'>
                      แก้ไข
                    </XText>
                  </TouchableOpacity>
                ) : null}
              </HStack>
              <HStack flex={1} justifyContent='flex-end'>
                <XText color={_.isNil(pendingOrderData) ? COLORS.RED : COLORS.TEXT_ACTIVE} fontSize='lg' bold>{`${xFmt.formatCurrency(
                  priceWithVat
                )}`}</XText>
              </HStack>
            </HStack>
            <HStack>
              <XText>{`${selectedMainPackage.billing_cycle} เดือน`}</XText>
              {_.isNil(pendingOrderData) ? (
                <TouchableOpacity
                  style={{ marginLeft: 4, paddingBottom: 4, width: 40 }}
                  onPress={() => {
                    if (mode === 'upgrade') {
                      // @ts-ignore
                      util.navGoBack(this.props)
                    } else {
                      this.setState({ isvisibleChangeBillingCycle: true })
                    }
                  }}>
                  <XText variant='inactive' textDecorationLine='underline'>
                    แก้ไข
                  </XText>
                </TouchableOpacity>
              ) : null}
            </HStack>
            <HStack>
              <XText>{`ช่วงเวลา ${billingCycleDateTime}`}</XText>
            </HStack>
            <HStack>
              <XText variant='inactive' fontSize={'xs'}>
                {'หมายเหตุ: 1 เดือน (รอบบิล) = 30 วัน'}
              </XText>
            </HStack>
          </VStack>
        </VStack>
      </XCard>
    )
  }

  _getAddOnCurrentPackageBySku = (sku: string) => {
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle)) {
      return null
    }

    const addOnlist = []
    const fullSku = currentPackageBillingCycle.find((addOn) => addOn.sku.startsWith(sku))?.sku
    // console.log('fullSku => ', fullSku)
    if (_.isNil(fullSku)) {
      return null
    }
    currentPackageBillingCycle.forEach((addOn) => {
      if (addOn.sku.startsWith(sku)) {
        addOnlist.push(addOn)
      }
    })
    return addOnlist.length > 0 ? addOnlist : null
  }

  // เอาไว้ render รายละเอียดแพ็กเสริม
  _renderAddOnCurrentPackageListDetail = (key: string, cutSku: string) => {
    // console.log('key => ', key)
    // console.log('cutSku => ', cutSku)
    const addOnPackageList = this._getAddOnCurrentPackageBySku(cutSku)
    // const diff = this._getDifferenceFromMainPackageAndNowPackage(key)
    const unit = util.getUnitNameByDataJsonKey(key)

    if (_.isNil(addOnPackageList)) {
      return null
    }
    // console.log('addOnPackageList => ', addOnPackageList)
    return (
      <VStack>
        {addOnPackageList.map((addOn) => {
          const { start_date, end_date, qty, sku } = addOn
          const addOnData = this._getCurrentSelectedAddOnDataByCutSku(sku)
          const { data_json } = addOnData
          const startPackage = dayjs(start_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          const endDataPackage = dayjs(end_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          return (
            <HStack w='full' key={addOn.sku}>
              <HStack flex={1}>
                <VStack>
                  <XText>{`มีแพ็กเสริมเพิ่ม ${data_json[key]} ${unit} x ${qty}`}</XText>
                  <XText variant='inactive' fontSize='xs'>
                    {`${startPackage} - ${endDataPackage}`}
                  </XText>
                </VStack>
              </HStack>
              <HStack flex={1} justifyContent='flex-end' alignItems='flex-start'>
                <XText>{`${data_json[key] * qty}`}</XText>
                <XText variant='inactive' fontSize='xs' ml='2' w='70px'>
                  {`${unit}`}
                </XText>
              </HStack>
            </HStack>
          )
        })}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderAddOnTitle = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { selectedMainPackage, mode } = this.state
    // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
    const newSelectedMainPackage = mode !== 'upgrade' ? _.cloneDeep(selectedMainPackage) : this._getMainPackageByUpgradePackageMode()
    // console.log('selectedMainPackage => ', selectedMainPackage)
    const { data_json } = newSelectedMainPackage
    const value = !_.isNil(data_json) ? data_json[addOn.addOnKey] : 0
    const unit = util.getUnitNameByDataJsonKey(addOn.addOnKey)
    let packageName = `แพ็กเกจ ${util.getSubscriptionTypeFullNameBySubType(newSelectedMainPackage.item_subtype)}`
    if (mode === 'upgrade' || mode === 'pending') {
      packageName = `แพ็กเกจ ${util.getSubscriptionTypeFullNameBySubTypeForUpgradeMode(newSelectedMainPackage.item_subtype)}`
      // packageName = selectedMainPackage.name
    }
    // const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(addOn.cutSku)
    // const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(sku)
    // const diff = this._getDifferenceFromMainPackageAndNowPackage(key)
    // const mainPackageDateTime = this._getMainPackageStarDateEndDateText()
    // if (_.isNil(selectedOrderAddOn) && _.isNil(pendingOrderData)) {
    //   return null
    // }
    return (
      <VStack>
        <HStack w='full'>
          <HStack flex={1}>
            <HStack>
              <XText variant='inactive'>{packageName}</XText>
              {/* <XText>{`แพ็กเสริม${unit}`}</XText> */}
            </HStack>
            {/* {!_.isNil(mainPackageDateTime) ? (
                <XText variant='inactive' fontSize='xs'>
                  {mainPackageDateTime}
                </XText>
              ) : null} */}
          </HStack>
          <HStack flex={1} justifyContent='flex-end' alignItems='flex-start'>
            <XText>{`${value}`}</XText>
            <XText variant='inactive' fontSize='xs' ml='2' w='75px'>
              {`${unit}`}
            </XText>
          </HStack>
        </HStack>

        {/* {this._renderAddOnCurrentPackageListDetail(key, sku)} */}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderAddOnSelectedTitle = (addOn: { title: string; addOnKey: string; cutSku: string }, sku: string) => {
    const { selectedMainPackage, pendingOrderData, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return null
    }
    let unitCount = selectedMainPackage?.data_json ? selectedMainPackage.data_json[addOn.addOnKey] : 0
    if (mode === 'upgrade') {
      // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
      const newSelectedMainPackage = this._getMainPackageByUpgradePackageMode()
      const { data_json } = newSelectedMainPackage
      unitCount = !_.isNil(data_json) ? data_json[addOn.addOnKey] : 0
    }
    // console.log('unitCount => ', unitCount)
    const getCountFromSelectedAddOn = this._getAddOnCount(addOn)
    unitCount += getCountFromSelectedAddOn
    const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(addOn.cutSku)
    // console.log('addOnKey => ', addOn.addOnKey)
    // console.log('unitCount => ', unitCount)
    // const sectedAddOn = this._getAddOnSelectedData(addOn.cutSku)
    let fontColor = COLORS.TEXT_ACTIVE
    if (!_.isNil(selectedOrderAddOn)) {
      // unitCount += selectedOrderAddOn.data_json[addOn.addOnKey] * sectedAddOn.qty
      fontColor = COLORS.GREEN
    }
    const { title } = addOn
    // const differenceFromMainPackageAndNowPackage = this._getDifferenceFromMainPackageAndNowPackage(addOn.addOnKey)
    const sumTotalAddonCurrentPackage = this._getSumAddonCurrentPackageBillingCycle(addOn.cutSku, addOn.addOnKey)
    // console.log('sumTotalAddonCurrentPackage => ', sumTotalAddonCurrentPackage)
    // const sumtotal = unitCount + diff
    const sumtotal = unitCount + sumTotalAddonCurrentPackage
    return (
      <HStack w='full'>
        <HStack flex={1} alignItems='center'>
          <XText fontSize='lg' bold>
            {title}
          </XText>
          {_.isNil(selectedOrderAddOn) && _.isNil(pendingOrderData) ? (
            <TouchableOpacity style={{ marginLeft: 4 }} onPress={() => this._onPressAddOn(sku)}>
              <XText color={COLORS.GREEN} textDecorationLine='underline'>
                เพิ่ม
              </XText>
            </TouchableOpacity>
          ) : null}
        </HStack>
        <HStack flex={1} justifyContent='flex-end' alignItems='center'>
          <XText variant='inactive' fontSize='xs' mr='2'>
            รวม
          </XText>
          <XText color={fontColor} fontSize='lg' bold>
            {`${xFmt.formatDecimal(sumtotal)}`}
          </XText>
          <XText variant='inactive' fontSize='xs' ml='2' w='75px'>
            {title}
          </XText>
        </HStack>
      </HStack>
    )
  }

  _renderSelectedAddOn = (cutSku: string) => {
    const { addOnPackages, pendingOrderData, mode, subscriptionPackageList } = this.state
    const selectedOrderAddOn = this._getSelectedAddOnDataByCutSku(cutSku)
    // console.log('addOnPackages => ', addOnPackages)
    // const unit = util.getUnitNameByDataJsonKey(key)
    if (_.isNil(selectedOrderAddOn) || _.isNil(addOnPackages)) {
      return null
    }

    const addOnBySku = this._getAddOnSelectedListData(cutSku)
    // console.log('addOnBySku => ', addOnBySku)
    // console.log('cutSku => ', cutSku)
    if (_.isNil(addOnBySku) || addOnBySku.length === 0) {
      return null
    }

    // const { subscription } = this.props
    return (
      <VStack space='2'>
        {addOnBySku.map((addOn) => {
          const { sku, billing_cycle, qty } = addOn
          // let unitCount = data_json[key]
          // console.log('addOn * => ', addOn)
          const seletedAddOn = this._getAddOnSelectedDataBySku(sku)
          // console.log('addOn => ', addOn)
          // console.log('seletedAddOn => ', seletedAddOn)
          const unitCount = seletedAddOn.data_json[seletedAddOn.item_subtype]
          // console.log('unitCount => ', unitCount)
          const price = seletedAddOn.price_with_vat
          const billingCycle = billing_cycle
          // if (key !== 'order_count_quota') {
          //   billingCycle = billing_cycle
          // }
          const sumTotalPrice = price * billingCycle * qty

          let billingCycleDateTime = util.getStartAndEndBillingCycle(subscriptionPackageList, billing_cycle, mode)
          if (mode === 'add_on') {
            billingCycleDateTime = util.getAddOnModeStartAndEndBillingCycle(subscriptionPackageList, billing_cycle)
          }
          // let billingCycleDateTime = this._getStartAndEndBillingCycle(billingCycle)
          // if (mode === 'add_on' || mode === 'upgrade') {
          //   const LOCAL_DATE_FORMAT = 'D MMM YYYY'
          //   const startBillingDate = subscription.has('start_billing_date')
          //     ? subscription.get('start_billing_date')
          //     : subscription.get('startBillingDate')
          //   const endBillingDate = subscription.has('end_billing_date')
          //     ? subscription.get('end_billing_date')
          //     : subscription.get('endBillingDate')
          //   const txtEndBillingDate = dayjs(endBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
          //   const txtStartBillingDate = dayjs(startBillingDate, CONS.SERVER_DATE_FORMAT).format(LOCAL_DATE_FORMAT)
          //   billingCycleDateTime = `${txtStartBillingDate} - ${txtEndBillingDate}`
          // }

          const unitSumCount = _.isNil(unitCount) ? 0 : unitCount
          const unit = util.getUnitNameByDataJsonKey(seletedAddOn.item_subtype)

          // const { future_billing_dates, current_billing_dates } = subscriptionPackageList
          // const startPackage = dayjs(current_billing_dates[0].start, 'YYYY-MM-DD').clone().format('D MMM YYYY')
          // const endDataPackage = dayjs(future_billing_dates[billingCycle - 1].end, 'YYYY-MM-DD')
          //   .clone()
          //   .format('D MMM YYYY')
          return (
            <XCard bgColor={COLORS.BG_LIGHT_GREY} p='2' mx='2' key={addOn.sku}>
              <HStack w='full'>
                <HStack flex={3}>
                  <VStack>
                    <XText color={COLORS.GREEN}>{`ซื้อเพิ่ม ${xFmt.formatDecimal(unitSumCount)} ${unit} x ${qty}`}</XText>
                    <XText variant='inactive' fontSize='xs'>
                      {`${billingCycleDateTime}`}
                    </XText>
                  </VStack>

                  {_.isNil(pendingOrderData) && !_.isNil(selectedOrderAddOn) ? (
                    <HStack w='10' justifyContent='flex-end'>
                      <TouchableOpacity style={{ marginLeft: 4, paddingBottom: 4, flex: 1 }} onPress={() => this._onPressEditAddOn(cutSku)}>
                        <XText variant='inactive' textDecorationLine='underline'>
                          แก้ไข
                        </XText>
                      </TouchableOpacity>
                    </HStack>
                  ) : null}
                </HStack>
                <HStack flex={2} justifyContent='flex-end' alignItems='flex-start'>
                  <XText color={COLORS.GREEN}>{xFmt.formatDecimal(unitSumCount * qty)}</XText>
                  <XText color={COLORS.GREEN} variant='inactive' fontSize='xs' ml='2' w='75px'>
                    {`${unit}`}
                  </XText>
                </HStack>
              </HStack>
              {/* <HStack h='6'>
                <HStack flex={1}>
                  <XText color={COLORS.GREEN}>{`ซื้อเพิ่ม ${unitSumCount} ${unit}`}</XText>
                </HStack>
                {_.isNil(pendingOrderData) ? (
                  <HStack w='10' justifyContent='flex-end'>
                    <TouchableOpacity style={{ marginLeft: 4, paddingBottom: 4, flex: 1 }} onPress={() => this._onPressEditAddOn(cutSku)}>
                      <XText variant='inactive' textDecorationLine='underline'>
                        แก้ไข
                      </XText>
                    </TouchableOpacity>
                  </HStack>
                ) : null}
              </HStack> */}

              {/* <XText variant='inactive'>{`${seletedAddOn.name} x ${qty}`}</XText> */}
              {/* <XText variant='inactive' fontSize='xs'>{`${xFmt.formatCurrency(price)}/รอบบิล`}</XText> */}
              {/* <XText variant='inactive' fontSize='xs'>{`${billingCycle} รอบบิล (${billingCycleDateTime})`}</XText> */}
              <HStack w='full'>
                <HStack flex={2}>
                  <XText variant='inactive' fontSize='xs'>{`${xFmt.formatCurrency(price)}/รอบบิล x ${billingCycle} รอบบิล x ${qty}`}</XText>
                </HStack>
                <HStack flex={1} justifyContent='flex-end' alignItems='center'>
                  <XText color={COLORS.RED} bold fontSize='lg'>
                    {xFmt.formatCurrency(sumTotalPrice)}
                  </XText>
                </HStack>
              </HStack>
            </XCard>
          )
        })}
      </VStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderOldAddonList = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { mode } = this.state
    if (mode === 'continue_package') {
      return null
    }
    const addOnList = this._getAddonCurrentPackageBillingCycle(addOn.cutSku)
    // console.log('addOnList => ', addOnList)
    if (_.isNil(addOnList) || addOnList.length === 0) {
      return null
    }

    return (
      <VStack space='2' mt='2'>
        {addOnList.map((addOnx) => {
          const { data_json, start_date, end_date, billing_cycle, qty, sku } = addOnx
          // ถ้า end_date อยู่ก่อน วันนี้ และเป็นโหมด add_on ไม่ต้องแสดง
          if (this._addOnOutDate(end_date)) {
            return null
          }
          const seletedAddOn = this._getAddOnSelectedDataBySku(sku)
          const unitCount = data_json[addOn.addOnKey]
          const billingCycle = billing_cycle
          // const sumTotalPrice = price * billingCycle * qty
          const billingCycleDateTime = `${dayjs(start_date, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end_date, 'YYYY-MM-DD').format(
            'D MMM YYYY'
          )}`
          const unitSumCount = _.isNil(unitCount) ? 0 : unitCount
          const unit = util.getUnitNameByDataJsonKey(seletedAddOn.item_subtype)
          return (
            <XCard bgColor={COLORS.BG_LIGHT_GREY} p='2' mx='2' key={addOnx.sku}>
              <HStack w='full'>
                <HStack flex={3}>
                  <VStack>
                    <XText variant='inactive'>{`แพ็กเสริมที่ซื้อไปแล้ว ${xFmt.formatDecimal(unitSumCount)} ${unit} x ${qty}`}</XText>
                    <XText variant='inactive' fontSize='xs'>
                      {`${billingCycleDateTime}`}
                    </XText>
                  </VStack>
                </HStack>
                <HStack flex={2} justifyContent='flex-end' alignItems='flex-start'>
                  <XText variant='inactive'>{xFmt.formatDecimal(unitSumCount * qty)}</XText>
                  <XText variant='inactive' fontSize='xs' ml='2' w='62px'>
                    {`${unit}`}
                  </XText>
                </HStack>
              </HStack>
              <HStack w='full'>
                <HStack flex={1}>
                  <XText variant='inactive' fontSize='xs'>{`${billingCycle} รอบบิล x ${qty}`}</XText>
                </HStack>
                {/* <HStack flex={1} justifyContent='flex-end' alignItems='center'>
                  <XText color={COLORS.TEXT_ACTIVE}>{xFmt.formatCurrency(sumTotalPrice)}</XText>
                </HStack> */}
              </HStack>
            </XCard>
          )
        })}
      </VStack>
    )
  }

  _renderOrderCountHistoryOverlay = () => {
    const { orderCountHistory, isOrderCountHistory } = this.state
    if (_.isNil(orderCountHistory)) {
      return null
    }
    return (
      <XOverlay visible={isOrderCountHistory} onRequestClose={() => this.setState({ isOrderCountHistory: false })}>
        <VStack p='2' w='full' h='160px'>
          <XOrderCountHistory orderCountHistory={orderCountHistory} />
          <TouchableOpacity
            style={{ borderRadius: 7, borderColor: COLORS.APP_MAIN, alignItems: 'center', borderWidth: 1, padding: 6, marginTop: 4 }}
            onPress={() => this.setState({ isOrderCountHistory: false })}>
            <XText color={COLORS.APP_MAIN}>ปิด</XText>
          </TouchableOpacity>
        </VStack>
      </XOverlay>
    )
  }

  _renderOrderCountHistory = (sku: string) => {
    const { orderCountHistory } = this.state
    // console.log('sku => ', sku)
    if (_.isNil(orderCountHistory) || sku !== 'ADDON-QUOTA-ORDER') {
      return null
    }
    let countNumber = 0
    orderCountHistory.forEach((order) => {
      const { order_count } = order
      if (order_count === 0) {
        countNumber += 1
      }
    })
    if (countNumber === orderCountHistory.length) {
      return null
    }
    return (
      <HStack w='full'>
        {/* <TouchableOpacity style={{ paddingBottom: 4 }} onPress={() => this._onPressEditAddOn(sku)}> */}
        <TouchableOpacity style={{ paddingBottom: 4 }} onPress={() => this.setState({ isOrderCountHistory: true })}>
          <XText variant='inactive' textDecorationLine='underline'>
            ดูประวัติการใช้งานออเดอร์
          </XText>
        </TouchableOpacity>
      </HStack>
    )
  }

  // cutSku EX: 'ADDON-QUOTA-ORDER' //addOnKey EX: 'order_count_quota'
  _renderQuotaUsage = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { quotaUsage } = this.state
    const { addOnKey } = addOn
    // console.log('addOnKey => ', addOnKey)
    // console.log('quotaUsage => ', quotaUsage)
    if (_.isNil(quotaUsage)) {
      return null
    }
    // return null
    let quotaUse = addOnKey === 'mkp_quota' ? quotaUsage.external_integrations : quotaUsage[addOn.addOnKey]
    // console.log('quotaUse => ', quotaUse)
    if ((addOnKey !== 'mkp_quota' && _.isNil(quotaUse)) || quotaUse === 0) {
      return null
    }
    if (
      (addOnKey === 'mkp_quota' && _.isNil(quotaUsage.external_integrations)) ||
      (addOnKey === 'mkp_quota' && quotaUsage.external_integrations.mkp === 0 && quotaUsage.external_integrations.erp === 0)
    ) {
      return null
    }
    if (addOnKey === 'mkp_quota') {
      quotaUse = quotaUsage.external_integrations.mkp + quotaUsage.external_integrations.erp
    }
    const unit = util.getUnitNameByDataJsonKey(addOnKey)
    const quotaUesTotal = this._getSumTotalQuota(addOn)
    // console.log('quotaUesTotal => ', quotaUesTotal)
    let TextColor = COLORS.TEXT_INACTIVE
    if (quotaUse > quotaUesTotal) {
      TextColor = COLORS.RED
    }
    let textQuotaUsage = `(ปัจจุบันใช้อยู่ ${quotaUse} ${unit})`
    if (addOnKey === 'mkp_quota') {
      textQuotaUsage = `(ปัจจุบันใช้อยู่ ${quotaUsage.external_integrations.mkp} ช่องทางขาย + ${quotaUsage.external_integrations.erp} ระบบบัญชี)`
    }
    return (
      <HStack flex={1} px='2' justifyContent={'flex-end'} alignItems={'center'}>
        <XText textAlign={'right'} color={TextColor} fontSize='xs'>
          {textQuotaUsage}
        </XText>
      </HStack>
    )
  }

  _renderAddOnView = (addOn: { title: string; addOnKey: string; cutSku: string }) => (
    <VStack w='full' borderBottomColor={COLORS.BG_LIGHT_GREY} borderBottomWidth='1' paddingBottom='2' mt='1' key={addOn.cutSku}>
      <VStack px='2'>
        {this._renderAddOnSelectedTitle(addOn, addOn.cutSku)}
        {this._renderOrderCountHistory(addOn.cutSku)}
        {this._renderAddOnTitle(addOn)}
      </VStack>
      {this._renderSelectedAddOn(addOn.cutSku)}
      {this._renderOldAddonList(addOn)}
      {this._renderQuotaUsage(addOn)}
    </VStack>
  )

  // xFmt.formatCurrency(80)
  _renderAddOnPackage = () => {
    const { selectedMainPackage, mode } = this.state
    if (_.isNil(selectedMainPackage) || _.isNil(this.ADD_ON_COUNTSTANT)) {
      return null
    }
    // console.log('selectedMainPackage => ', selectedMainPackage)
    let packageName = `รายละเอียดแพ็กเกจ ${util.getSubscriptionTypeFullNameBySubType(selectedMainPackage.item_subtype)}`
    if (mode === 'upgrade' || mode === 'add_on') {
      packageName = 'รายละเอียดแพ็กเกจ'
    }
    return (
      <XCard mx='2' mt='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10' w='full'>
          <XText textAlign='center' bold fontSize='lg'>
            {`${packageName}`}
          </XText>
        </HStack>
        <VStack>{this.ADD_ON_COUNTSTANT.map((addOn) => this._renderAddOnView(addOn))}</VStack>
      </XCard>
    )
  }

  _renderOrderSummaryList = (title: string, billingCycle: number, summary: number | string, mainPackage = false) => {
    const { mode } = this.state
    // console.log('MODE => ', mode)
    if (mode === 'add_on' && mainPackage) {
      return null
    }
    if (mode === 'pending' && mainPackage) {
      const showPackage = this._showMainPackage()
      if (!showPackage) {
        return null
      }
    }
    const { subscriptionPackageList, selectedMainPackage } = this.state
    // const billingCycleDateTime = this._getStartAndEndBillingCycle(billingCycle)
    const pendingModeCheck = subscriptionUtil.pendingModeCheck(selectedMainPackage, mode)
    let billingCycleDateTime = util.getStartAndEndBillingCycle(subscriptionPackageList, billingCycle, pendingModeCheck)
    if (mode === 'add_on') {
      billingCycleDateTime = util.getAddOnModeStartAndEndBillingCycle(subscriptionPackageList, billingCycle)
    }
    return (
      <VStack p='2' w='full' key={title}>
        <VStack w='full'>
          <HStack w='full'>
            <HStack flex={2}>
              <XText>{title}</XText>
            </HStack>
            <HStack flex={1} justifyContent='flex-end'>
              <XText>{xFmt.formatCurrencyFixedPoint(summary, 2)}</XText>
            </HStack>
          </HStack>
          <XText variant='inactive'>{`${billingCycle} รอบบิล (${billingCycleDateTime})`}</XText>
        </VStack>
      </VStack>
    )
  }

  _renderOrderAddOnSummary = () => {
    const { addOnPackages } = this.state
    if (_.isNil(addOnPackages)) {
      return null
    }
    // สร้างลำดับการเรียงโดยเทียบ cutSku
    const sortedData = this.ADD_ON_COUNTSTANT.map(({ cutSku }) => {
      return addOnPackages.find((item) => item.sku.startsWith(cutSku))
    }).filter(Boolean) // กรองออกถ้าไม่มี match
    // console.log('addOnPackages => ', addOnPackages)
    // console.log('sortedData => ', sortedData)
    return (
      <VStack>
        {sortedData.map((addOn) => {
          const { billing_cycle, qty, sku } = addOn
          const selectedPackage = this._getAddOnSelectedDataBySku(sku)
          const name = `${selectedPackage.name} x ${qty}`
          const price = selectedPackage.price_with_vat * qty * billing_cycle
          return this._renderOrderSummaryList(name, billing_cycle, price)
        })}
      </VStack>
    )
  }

  _renderOrderSummaryTotal = () => {
    const { selectedMainPackage, isTaxWithheld, resultPayment } = this.state
    if (_.isNil(selectedMainPackage) || _.isNil(resultPayment)) {
      return null
    }
    // const price = this._getSumTotalPayment()
    // const sumTotalPriceBeforeVat = this._getSumTotalPriceBeforeVat()
    // const sumTotalVat = this._getSumTotalVat()
    // const whTex = isTaxWithheld ? this._getSumTotalWhTex() : 0
    // const sumTotalPrice = isTaxWithheld ? price - whTex : price
    // console.log('sumTotalPriceBeforeVat => ', sumTotalPriceBeforeVat)
    // console.log('resultPayment => ', resultPayment)
    const PRICE_BEFORE_VAT = resultPayment.sub_total_amount
    const VAT = resultPayment.vat_amount
    const PRICE_WITH_VAT = resultPayment.vat_amount + resultPayment.sub_total_amount
    const TOTAL_PRICE = resultPayment.total_amount
    const Wh_TEX = resultPayment?.wh_tax_amount || 0
    // console.log('Wh_TEX => ', Wh_TEX)
    return (
      <VStack>
        <HStack borderBottomColor={COLORS.TEXT_ACTIVE} borderBottomWidth='1' borderStyle='dotted' />
        {/* <HStack p='2'>
          <HStack flex={2}>
            <XText bold>รวมยอดคำสั่งซื้อ</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText bold>{xFmt.formatCurrency(price)}</XText>
          </HStack>
        </HStack> */}
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>ราคาก่อน VAT</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(PRICE_BEFORE_VAT, 2)}</XText>
          </HStack>
        </HStack>
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>VAT 7%</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(VAT, 2)}</XText>
          </HStack>
        </HStack>
        <HStack p='2'>
          <HStack flex={2}>
            <XText variant='inactive'>ราคารวม VAT</XText>
          </HStack>
          <HStack flex={1} justifyContent='flex-end'>
            <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(PRICE_WITH_VAT, 2)}</XText>
          </HStack>
        </HStack>
        {_.isNil(Wh_TEX) || Wh_TEX === 0 ? null : (
          <HStack p='2'>
            <HStack flex={2}>
              <XText variant='inactive'>หักภาษี ณ ที่จ่าย 3%</XText>
            </HStack>
            <HStack flex={1} justifyContent='flex-end'>
              <XText variant='inactive'>{xFmt.formatCurrencyFixedPoint(Wh_TEX, 2)}</XText>
            </HStack>
          </HStack>
        )}

        <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' borderStyle='dotted' />

        <VStack bgColor={COLORS.BG_GREY_PACKAGE}>
          <HStack p='2' w='full'>
            <HStack flex={2}>
              <XText bold fontSize='lg'>
                ยอดสุทธิ
              </XText>
            </HStack>
            <VStack flex={1} justifyContent='flex-end'>
              <XText bold fontSize='lg' textAlign='right'>
                {xFmt.formatCurrencyFixedPoint(TOTAL_PRICE, 2)}
              </XText>
              <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' />
              <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='3' mt='1' />
            </VStack>
          </HStack>
        </VStack>
      </VStack>
    )
  }

  _renderOrderSummary = () => {
    const { selectedMainPackage, mode } = this.state
    // console.log('selectedMainPackage => ', selectedMainPackage)
    if (_.isNil(selectedMainPackage)) {
      return null
    }
    const { name, billing_cycle, price_with_vat } = selectedMainPackage
    // console.log('selectedMainPackage => ', selectedMainPackage)
    const priceWithVat = price_with_vat
    return (
      <XCard mx='2' mt='2' flex={1}>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10' w='full'>
          <XText textAlign='center' bold fontSize='lg'>
            สรุปคำสั่งซื้อ
          </XText>
        </HStack>
        {!_.isNil(selectedMainPackage) ? this._renderOrderSummaryList(name, billing_cycle, priceWithVat, true) : null}
        {this._renderOrderAddOnSummary()}
        {this._renderOrderSummaryTotal()}
      </XCard>
    )
  }

  _renderScbPayment = () => (
    <VStack w='full' alignItems='center' justifyContent='center' m='2'>
      <XCard
        p='2'
        w='72'
        borderWidth='1'
        borderColor={COLORS.SCB_MAIN}
        bgColor='#ECE8F1'
        onPress={() => {
          Clipboard.setString('1623004722')
          p.op.showToast(`คัดลอกเลขบัญชี 1623004722 เรียบร้อยแล้ว`, 'success')
        }}>
        <HStack>
          <HStack w='16'>
            <XImage source={IMG_SCB} w='16' h='16' />
          </HStack>
          <VStack flex={1} ml='2'>
            <XText>ธนาคาร ไทยพาณิชย์ (SCB)</XText>
            <XText>สาขา บางแค</XText>
          </VStack>
        </HStack>
        <VStack w='full' alignItems='center' justifyContent='center'>
          <XText fontSize='md'>บริษัท เอฟฟิลี่ จำกัด</XText>
          <XText fontSize='lg' color={COLORS.SCB_MAIN}>
            162-3-00472-2
          </XText>
          <XText fontSize='xs' textDecorationLine='underline'>
            คัดลอกเลขที่บัญชี
          </XText>
        </VStack>
      </XCard>
    </VStack>
  )

  _renderSumTotalPayment = () => {
    const { resultPayment } = this.state
    // const price = this._getSumTotalPayment()
    // const whTex = this._getSumTotalWhTex()
    const sumTotalPrice = _.isNil(resultPayment) ? 0 : resultPayment.total_amount
    return (
      <HStack w='full' justifyContent='center' alignItems='center' mx='2' mt='2'>
        <XText fontSize='md' bold>
          ยอดสุทธิชำระ
        </XText>
        <VStack w='24' justifyContent='flex-end' mx='2'>
          <XText bold fontSize='md' textAlign='center'>
            {xFmt.formatCurrencyFixedPoint(sumTotalPrice, 2)}
          </XText>
          <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='1' />
          <HStack borderTopColor={COLORS.TEXT_ACTIVE} borderTopWidth='3' mt='1' />
        </VStack>
        <TouchableOpacity
          onPress={() => {
            Clipboard.setString(`${sumTotalPrice}`)
            p.op.showToast(`คัดลอกยอดชำระ ${xFmt.formatCurrencyFixedPoint(sumTotalPrice, 2)} เรียบร้อยแล้ว`, 'success')
          }}
          style={{
            width: 120,
            justifyContent: 'center',
            alignItems: 'center',
            borderWidth: 1,
            borderColor: COLORS.APP_MAIN,
            borderRadius: 90,
            paddingBottom: 6,
            paddingTop: 6,
          }}>
          <XText color={COLORS.APP_MAIN}>คัดลอกยอดชำระ</XText>
        </TouchableOpacity>
      </HStack>
    )
  }

  _renderDateTimePickerCard = () => {
    const { paymentPostDate } = this.state

    return (
      <VStack w='full'>
        <XText variant='inactive'>เวลาชำระ</XText>
        <HStack w='full' minH='9'>
          <XDateTimeSinglePicker selectedDate={paymentPostDate || new Date()} onChangeDate={this._onChangePaymentPostDate} />
        </HStack>
      </VStack>
    )
  }

  _renderPendingOrder = () => {
    const { selectedMainPackage, pendingOrderData } = this.state
    if (_.isNil(selectedMainPackage) || _.isNil(pendingOrderData)) {
      return null
    }
    const { payment } = pendingOrderData
    const { status } = payment
    const FOOTER_COMPONENT = () =>
      !_.isNil(status) && status === 'unpaid' ? (
        <TouchableOpacity
          // eslint-disable-next-line react/no-this-in-sfc
          onPress={() => this._navToPaymentSubscriptionView()}
          style={{
            backgroundColor: COLORS.APP_MAIN,
            borderRadius: 90,
            alignContent: 'center',
            justifyContent: 'center',
            alignSelf: 'center',
            height: 41,
            width: 90,
          }}>
          <XText color={COLORS.WHITE} bold textAlign='center'>
            ชำระเงิน
          </XText>
        </TouchableOpacity>
      ) : null
    return (
      <XPendingSubcriptionPayment
        packageName={selectedMainPackage.name}
        pendingOrderData={pendingOrderData}
        footerComponent={FOOTER_COMPONENT}
      />
    )
  }

  _renderChangeBillingCycleOverlay = () => {
    const { isvisibleChangeBillingCycle, selectedMainPackage, subscriptionPackageList } = this.state
    if (_.isNil(selectedMainPackage)) {
      return null
    }
    // console.log('subscriptionPackageList => ', subscriptionPackageList)
    return (
      <ChangeBillingCycle
        visible={isvisibleChangeBillingCycle}
        onRequestClose={() => this.setState({ isvisibleChangeBillingCycle: false })}
        mainPackageSku={selectedMainPackage.sku}
        subscriptionPackageList={subscriptionPackageList}
        billingCycle={selectedMainPackage.billing_cycle}
        onSelected={(month) => this._onChangeBillingCycle(month)}
        key={selectedMainPackage.sku}
      />
    )
  }

  _renderSubscriptionAddressContactCard = () => {
    const { subscriptionAddressContact, pendingOrderData } = this.state
    // console.log('subscriptionAddressContact => ', subscriptionAddressContact)
    const txtReceiver = _.isNil(subscriptionAddressContact)
      ? 'ยังไม่ได้ระบุที่อยู่'
      : addressUtil.convertAddressToInlineAddress(subscriptionAddressContact)
    // const txtReceiver = 'ยังไม่ได้ระบุที่อยู่'
    return (
      <XCard w='full' mt='2' onPress={() => this._navToEditAddressView()} disabled={!_.isNil(pendingOrderData)}>
        <XCard.Body>
          <HStack w='full' alignItems='center' justifyContent='space-between' space='1'>
            <HStack flex={1} space='1'>
              <XIcon variant={!_.isNil(pendingOrderData) ? 'inactive' : 'primary'} family='FontAwesome' name='home' />
              <VStack flex={1} flexWrap='wrap'>
                <XText variant='inactive'>ที่อยู่สำหรับใบกำกับภาษี</XText>
                <XText w='full'>{txtReceiver}</XText>
              </VStack>
            </HStack>
            <XIcon
              variant={_.isNil(pendingOrderData) ? 'primary' : 'inactive'}
              style={{
                fontSize: STYLES.FONT_ICON_NORMAL,
                // color: true ? COLORS.TEXT_PRIMARY : COLORS.TEXT_PRIMARY,
              }}
              name='arrow-forward'
            />
          </HStack>
        </XCard.Body>
      </XCard>
    )
  }

  _renderTaxReceiptRequested = () => {
    const { isTaxReceiptRequested, isTaxWithheld, pendingOrderData } = this.state
    const isShowWithheld = this._showWithheld()
    // console.log('isTaxReceiptRequested => ', isTaxReceiptRequested)
    const onChangeChackbox = async () => {
      if (!_.isNil(pendingOrderData)) {
        return
      }
      // this.setState({
      //   isTaxReceiptRequested: !isTaxReceiptRequested,
      //   isTaxWithheld: !isTaxReceiptRequested === false ? false : isShowWithheld,
      // })
      await util.setStatePromise(this, {
        isTaxReceiptRequested: !isTaxReceiptRequested,
        isTaxWithheld: !isTaxReceiptRequested === false ? false : isShowWithheld,
      })
      await this._validateOrder()
    }
    const onChangeTaxWithheldChackbox = async () => {
      await util.setStatePromise(this, {
        isTaxWithheld: !isTaxWithheld,
      })
      await this._validateOrder()
    }
    const isTaxWithheldFinal = !_.isNil(pendingOrderData) ? pendingOrderData.is_tax_withheld : isTaxWithheld
    const isTaxReceiptRequestedFinal = !_.isNil(pendingOrderData) ? pendingOrderData.is_tax_receipt_requested : isTaxReceiptRequested
    const renderTaxWithheld = () => (
      <TouchableOpacity
        disabled={!_.isNil(pendingOrderData)}
        onPress={() => {
          if (!_.isNil(pendingOrderData)) {
            return
          }
          onChangeTaxWithheldChackbox()
        }}>
        <HStack alignItems='center'>
          <XIcon
            family='FontAwesome'
            name={isTaxWithheldFinal ? 'check-square-o' : 'square-o'}
            variant={!_.isNil(pendingOrderData) ? 'inactive' : 'primary'}
          />
          <XText variant='active' ml='2'>
            หัก ณ ที่จ่าย
          </XText>
        </HStack>
      </TouchableOpacity>
    )
    return (
      <XCard mx='2' mt='2'>
        <HStack bgColor={COLORS.BG_GREY_PACKAGE} alignItems='center' justifyContent='center' h='10' w='full'>
          <XText textAlign='center' bold fontSize='lg'>
            ใบกำกับภาษี
          </XText>
        </HStack>
        <VStack p='2'>
          <TouchableOpacity onPress={() => onChangeChackbox()} disabled={!_.isNil(pendingOrderData)}>
            <HStack alignItems='center'>
              <HStack w='6'>
                <XIcon
                  family='FontAwesome'
                  name={isTaxReceiptRequestedFinal ? 'check-square-o' : 'square-o'}
                  variant={!_.isNil(pendingOrderData) ? 'inactive' : 'primary'}
                />
              </HStack>
              <XText variant='active' ml='2'>
                {'ใบกำกับภาษี '}
              </XText>
            </HStack>
            <HStack>
              <HStack w='6' />
              <XText variant='inactive' ml='2'>
                (นำส่งทาง email ในรูปแบบ eTax-Invoice)
              </XText>
            </HStack>
          </TouchableOpacity>
          {isTaxReceiptRequestedFinal ? renderTaxWithheld() : null}
          {isTaxReceiptRequestedFinal ? this._renderSubscriptionAddressContactCard() : null}
        </VStack>
      </XCard>
    )
  }

  _renderFooterBtn = () => {
    const { isLoading, pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return null
    }
    return (
      <HStack justifyContent='center' alignItems='center' my='2' mx='1'>
        <XButton
          flex={1}
          h='12'
          isDisabled={isLoading}
          onPress={() => this._onSubmitPayment()}
          style={{ alignItems: 'center', justifyContent: 'center', alignContent: 'center' }}>
          <XText fontSize={'lg'} bold textAlign={'center'} color={COLORS.WHITE}>
            ยืนยัน
          </XText>
        </XButton>
      </HStack>
    )
  }

  render() {
    const { isLoading } = this.state
    return (
      <XContainer>
        {this._renderHeader()}
        <XContent>
          <VStack bgColor={COLORS.WHITE}>
            {this._renderProfile()}
            {this._renderPendingOrder()}
            {this._renderTitleDescription()}
            {/* {this._renderSelectedMonthPackage()} */}
            {this._renderMySelectedPackage()}
            {this._renderAddOnPackage()}
            {this._renderOrderSummary()}
            {this._renderTaxReceiptRequested()}
            {this._renderPendingOrder()}
            {/* {this._renderBankPayment()} */}
            {this._renderFooterBtn()}

            {this._renderChangeBillingCycleOverlay()}
            {this._renderOrderCountHistoryOverlay()}
            {isLoading ? (
              <VStack
                alignItems='center'
                justifyContent='center'
                bg='gray.400:alpha.50'
                style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }}>
                <XSpinner />
              </VStack>
            ) : null}
          </VStack>
        </XContent>
      </XContainer>
    )
  }
}
